import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Helmet from 'react-helmet';
import { StickyProvider } from 'react-stickup';
import { ParallaxProvider } from 'react-scroll-parallax';
import { DownloadAppProvider } from '../utils/download';
import { RequestDemoProvider } from '../utils/demo';
import Header from './Header';
import Footer from './Footer';
import '../styles/styles.scss';

const Layout = ({ children, location }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  useEffect(() => {
    if (location.pathname.startsWith('/about')) {
      document.body.classList.add('hidetopbar');
    } else {
      document.body.classList.remove('hidetopbar');
    }
  }, []);
  const mainRef = useRef();

  const loadHandler = useCallback(() => {
    if (mainRef.current && document.readyState === 'complete')
      mainRef.current.className = 'loaded';
  }, []);

  useEffect(() => {
    if (location) loadHandler();
  }, [location, loadHandler]);

  useEffect(() => {
    window.addEventListener('load', loadHandler);

    return () => window.removeEventListener('load', loadHandler);
  }, [loadHandler]);

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
      </Helmet>
      <StickyProvider>
        <ParallaxProvider>
          <DownloadAppProvider>
            <RequestDemoProvider>
              <Header siteTitle={data?.site?.siteMetadata?.title || `Title`} />
              <main ref={mainRef} id="main">
                {children}
              </main>
              <Footer />
            </RequestDemoProvider>
          </DownloadAppProvider>
        </ParallaxProvider>
      </StickyProvider>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};

export default Layout;
